import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ReactModal from 'react-modal'
import InstagramDeleteModal from '../../pages/instagram/InstagramDeleteModal' // Assuming DeleteModal is in this path

// Mock images for better visual representation, similar to the screenshot
const mockImages = [
  'https://i.imgur.com/uJm84wK.png',
  'https://i.imgur.com/sC4p1sT.png',
  'https://i.imgur.com/vHqT8Yt.png'
]

interface IProps {
  bot: any
  index: number
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  fetchAllBots: () => void
}

const InstagramBotCard: React.FC<IProps> = ({ bot, index, setIsLoading, fetchAllBots }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  console.log(bot)
  const openDeleteModal = () => setIsDeleteModalOpen(true)
  const closeDeleteModal = () => setIsDeleteModalOpen(false)

  const customDeleteModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      padding: '0px',
      boxShadow: '0 2px 8px 0 #00000029'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    }
  }

  return (
    <>
      <div
        className='card p-4'
        style={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #EAE5F5',
          borderRadius: '1.25rem',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)'
        }}
      >
        <div className='d-flex align-items-center gap-4'>
          {/* Bot Image */}
          <img
            src={
              bot.imageLink ||
              'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png'
            }
            alt={bot.botName}
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '1rem',
              objectFit: 'cover'
            }}
          />

          {/* Bot Name and Description */}
          <div className='flex-grow-1'>
            <h5 className='card-title fw-bolder text-dark mb-1 fs-4'>{bot.botName}</h5>
            <p className='card-text text-muted fs-7 mb-0'>
              <span className='fw-semibold'>Bot Description:</span> {bot.botDescription}
            </p>
          </div>

          {/* Action Icons */}
          <div className='d-flex align-items-center gap-3'>
            <Link
              to={`/instagram-bots/bot-builder/${bot.instagramIDString}`}
              className='btn btn-icon btn-sm border-0'
            >
              <i className='bi bi-pencil-square text-info fs-4'></i>
            </Link>
            <button onClick={openDeleteModal} className='btn btn-icon btn-sm border-0'>
              <i className='bi bi-trash text-danger fs-4'></i>
            </button>
          </div>
        </div>
      </div>

      <ReactModal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        style={customDeleteModalStyles}
        contentLabel='Delete Bot'
        appElement={document.getElementById('root') || undefined}
      >
        <InstagramDeleteModal
          bot={bot}
          setIsLoading={setIsLoading}
          closeDeleteModal={closeDeleteModal}
          fetchAllBots={fetchAllBots}
        />
      </ReactModal>
    </>
  )
}

export default InstagramBotCard
